// extracted by mini-css-extract-plugin
export default {"changeValue":"br_gz","positive":"br_gB","negative":"br_gC"};